import { render, staticRenderFns } from "./TemplateStepTipoSolicitacao.vue?vue&type=template&id=23215f12"
import script from "./TemplateStepTipoSolicitacao.vue?vue&type=script&lang=js"
export * from "./TemplateStepTipoSolicitacao.vue?vue&type=script&lang=js"
import style0 from "./TemplateStepTipoSolicitacao.vue?vue&type=style&index=0&id=23215f12&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports